import { useQuery } from '@tanstack/react-query';

import { fetchSkuGroups, fetchSkuItemsForSubgroups, fetchSkuSubgroups } from 'features/Sku/Items/SkuItems.helpers';
import { skuMenuKeys } from 'features/Sku/Items/skuMenuKeys';

import { toItemCatalogue } from './Modifiers.itemSelection';

// Deliberately on the menu page's own query keys, so the editor shares its cache.
export default function useModifierItemCatalogue(venueId) {
  const menusQuery = useQuery({
    queryKey: skuMenuKeys.menus(venueId),
    queryFn: () => fetchSkuGroups(venueId),
    enabled: !!venueId,
    refetchOnWindowFocus: false,
  });

  const detailsQuery = useQuery({
    queryKey: skuMenuKeys.details(venueId),
    queryFn: async () => {
      const categories = await fetchSkuSubgroups(venueId);
      const items = await fetchSkuItemsForSubgroups(venueId, categories);
      return { categories, items };
    },
    enabled: !!venueId,
    refetchOnWindowFocus: false,
  });

  return {
    items: toItemCatalogue({
      menus: menusQuery.data ?? [],
      categories: detailsQuery.data?.categories ?? [],
      items: detailsQuery.data?.items ?? [],
    }),
    isLoading: menusQuery.isLoading || detailsQuery.isLoading,
    isError: menusQuery.isError || detailsQuery.isError,
  };
}
